// @flow
import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';

import {Fab} from '@mui/material';
import InspectionAssignInformation from '../../InspectionAssignInformation';
import InspectionResultsView from '../InspectionResultsView';
import InspectionTrendView from '../InspectionTrendView';
import _ from 'lodash';
import {setCrumbPath, initInspectionDraft, showSnackbar, fetchDetailInspectionAssign} from '../../../actions';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppModule from '../../AppModule';
import TableActionHeader from '../../TableActionHeader/TableActionHeader';
import { fetchCSV, fetchPDF, fetchInspectionDetail } from '../../../lib/api';
import classnames from 'classnames';
import DescIcon from '@mui/icons-material/Description';
import InsertIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/GetApp';
import CloseIcon from '@mui/icons-material/Close';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';
import {withRouter} from "react-router";
import classes from './InspectionDetailView.module.scss';
import colors from "../../../lib/themes/theme.scss";



type Props = {
    match: any,
    toolbox?: any,
    fetchEmployee: () => mixed,
    fetchSectors: () => mixed,
    fetchCategories: () => mixed,
    fetchInspections: () => mixed,
    fetchInspectionAssigns: () => mixed,
    setCrumbPath: (inspectionName: string) => void,
};

type State = {
    tab: number,
    inspectionAssign: any,
};

const mapStateToProps = (store, props) => {
    const inspectionAssigns = store.entities.inspectionAssigns;
    const allEmployees = store.entities.employees;

    return {
        inspectionAssigns: inspectionAssigns,
        allEmployees: allEmployees,
        allSectors: store.entities.sectors,
        allCategories: store.entities.categories,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        initDraft: (inspection) => {
            dispatch(initInspectionDraft(inspection));
        },
        getDetailInspectionAssign: (id) => {
            dispatch(fetchDetailInspectionAssign(id));
        },
        showSnackbar: (message: string) => dispatch(
            showSnackbar(message)
        ),
        setCrumbPath:
            ownProps.setCrumbPath ||
            ((inspectionAssign) => {

                const hash = '?' + ownProps.location.hash.split('?')[1];
                let page = new URLSearchParams(hash).get("page");
                let project = new URLSearchParams(hash).get("project");
                let rowsPerPage = new URLSearchParams(hash).get("rowsPerPage");
                let searchString = new URLSearchParams(hash).get("searchString");
                let typeFilterText = new URLSearchParams(hash).get("typeFilter");
                if (page === null || rowsPerPage === null) {
                    page = 0; rowsPerPage = 10;
                }
                console.log("INFO calling setCrumbPath in InspectionDetailView: hash = " + hash + " page="+page + "rowsPerPage="+rowsPerPage);

                if (ownProps.location.hash.includes("#ingepland")) {
                    dispatch(
                        setCrumbPath({
                            title: 'Werkplekinspecties',
                            crumbs: [
                                {
                                    name:
                                        i18n.t('Scheduled') +
                                        ': ' +
                                        inspectionAssign.inspection.title,
                                    link:
                                        '/werkplekinspecties#ingepland?page=' + page + '&rowsPerPage=' + rowsPerPage,
                                },
                            ],
                        })
                    );
                } else if (ownProps.location.hash.includes("#uitgestuurd")) {
                    dispatch(
                        setCrumbPath({
                            title: 'Werkplekinspecties',
                            crumbs: [
                                {
                                    name:
                                        i18n.t('Sent out') +
                                        ': ' +
                                        inspectionAssign.inspection.title,
                                    link:
                                        '/werkplekinspecties#uitgestuurd?page=' + page + '&rowsPerPage=' + rowsPerPage   + '&searchString='+ searchString + '&typeFilter=' + typeFilterText,
                                },
                            ],
                        })
                    );
                } else if (ownProps.location.hash.includes("#mail")) {
                    dispatch(
                        setCrumbPath({
                            title: 'Werkplekinspecties',
                            crumbs: [
                                {
                                    name:
                                        'Uitgestuurd: ' +
                                        inspectionAssign.inspection.title,
                                    link:
                                        '/werkplekinspecties#resultaten?page=' + page + '&rowsPerPage=' + rowsPerPage,
                                },
                            ],
                        })
                    );
                } else if (project) {
                    dispatch(
                        setCrumbPath({
                            title: 'Projecten/Werkgebieden',
                            crumbs: [
                                {
                                    name:
                                        'Uitgestuurd: ' +
                                        inspectionAssign.inspection.title,
                                    link:
                                        '/projecten/details/'+project,
                                },
                            ],
                        })
                    );

                } else {
                    dispatch(
                        setCrumbPath({
                            title: 'Werkplekinspecties',
                            crumbs: [
                                {
                                    name: inspectionAssign.inspection.title,
                                    link:
                                        '/werkplekinspecties#overzicht?page=' + page + '&rowsPerPage=' + rowsPerPage,
                                },
                            ],
                        })
                    );
                }
            }),
    };
};

class InspectionDetailView extends React.Component<Props, State> {
    props: Props;
    state: State = {
        tab: 0,
        inspectionAssign: null,
    };

    componentWillMount() {
        // Fetch detail inspection assign
        const inspectionAssignId = this.props.match.params.inspectionId;
        fetchInspectionDetail(inspectionAssignId)
            .then((entities) => {
                this.setState({
                    inspectionAssign: entities.body._embedded.inspectionAssign
                });
                this.props.setCrumbPath(entities.body._embedded.inspectionAssign);

            })
            .catch((error) => {
                showSnackbar(
                    `${i18n.t(
                        'Unknown error while fetching fetchDetailInspectionAssign'
                    )}: ` + error.message
                )
                throw error;
            });
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.inspectionAssign &&
            _.get(this, 'props.inspection.id', null) !==
                _.get(nextProps, 'inspection.id', null)
        ) {
            this.props.initDraft(nextProps.inspection);
            this.props.setCrumbPath(nextProps.inspectionAssign);
        }
    }

    handleTabChange = (event: any, value: number) => {
        this.setState({ tab: value });
    };

    componentDidMount() {
        //let tabs;
        // Inspection will be undefined after the speed improvements update, keeping this as future reference
        // this.props.inspection !== undefined ? tabs = ['#voorbeeld', '#informatie', '#resultaten'] : tabs = ['#informatie', '#resultaten'];
        //tabs = ['#informatie', '#resultaten', '#trend'];
        // Set default tab to #resultaten
        this.setState({
            tab: 1,
        });

        console.log("INFO: componentDidMount try to set page and rowsPerPage");
        if (this.props.location.search.includes("page")) {
            const fromPage = new URLSearchParams(this.props.location.search).get("page");

            this.setState({ page: Number(fromPage) });
        }
        if (this.props.location.search.includes("rowsPerPage")) {
            const rowsPerPage = new URLSearchParams(this.props.location.search).get("rowsPerPage");
            this.setState({ rowsPerPage: Number(rowsPerPage) });
        }


    }

    handlePDFClick = () => {
        const { inspectionAssign } = this.state;
        const {  allEmployees } = this.props;
        const { result } = inspectionAssign;
        const title =
            this.props.inspection == null
                ? inspectionAssign.inspection.title
                : this.props.inspection.title;
        const version =
            this.props.inspection == null
                ? inspectionAssign.inspection.version
                : this.props.inspection.version;

        fetchPDF({
            platform: 'VV',
            customer: 'VV',
            template: 'INSPECTION',
            options: {},
            data: inspectionAssign.inspection.inspection.categories,
            info: {
                ...inspectionAssign,
                resultEmployees:
                    result != null && result.employees != null
                        ? result.employees.map((id) => {
                              return allEmployees.byId[id];
                          })
                        : [],
                showResults: true,
                address: this.state.address ? this.state.address : '-',
                kamComment: inspectionAssign.kamComment,
                kamResolved: inspectionAssign.kamResolved,
                inspectionAssign,
            },
        })
            .then((res) => {
                var encodedUri = window.URL.createObjectURL(res.body);
                var link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', title + ' v' + version + '.pdf');
                document.body.appendChild(link);
                link.click(); //
            })
            .catch((err) => console.log(err));
    };

    handleCSVClick = () => {
        const { inspectionAssign } = this.state;
        const { t } = this.props;
        const title =
            this.props.inspection == null
                ? inspectionAssign.inspection.title
                : this.props.inspection.title;
        const version =
            this.props.inspection == null
                ? inspectionAssign.inspection.version
                : this.props.inspection.version;

        let items = [];

        inspectionAssign.inspection.inspection.categories.forEach((c) => {
            c.items.forEach((i) => {
                i.resultaat = i.result.remark.unsafe
                    ? t('Unsafe situation')
                    : i.result.result === 'ok'
                    ? t('Correct')
                    : i.result.result === 'nok'
                    ? t('Not correct')
                    : t('Does not apply');
                items.push(i);
            });
        });

        fetchCSV({
            platform: 'VV',
            customer: 'VV',
            template: 'INSPECTIONPREVIEW',
            options: {},
            data: items,
            info: {},
        })
            .then((res) => {
                var encodedUri = window.URL.createObjectURL(res.body);
                var link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', title + ' v' + version + '.csv');
                document.body.appendChild(link);
                link.click(); //
            })
            .catch((err) => console.log(err));
    };

    handlePDFClickNoResults = () => {
        const { inspectionAssign, allEmployees } = this.props;
        const { result } = inspectionAssign;

        fetchPDF({
            platform: 'VV',
            customer: 'VV',
            template: 'INSPECTION',
            options: {},
            data: inspectionAssign.inspection.inspection.categories,
            info: {
                ...inspectionAssign,
                resultEmployees:
                    result != null && result.employees != null
                        ? result.employees.map((id) => {
                              return allEmployees.byId[id];
                          })
                        : [],
                showResults: false,
                inspectionAssign,
            },
        })
            .then((res) => {
                var encodedUri = window.URL.createObjectURL(res.body);
                var link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute(
                    'download',
                    inspectionAssign.inspection.title +
                        ' v' +
                        inspectionAssign.inspection.version +
                        '.pdf'
                );
                document.body.appendChild(link);
                link.click(); //
            })
            .catch((err) => console.log(err));
    };

    toggleExport = () => {
        if (this.state && this.state.exportOpen) {
            this.setState({
                exportOpen: false,
            });
        } else {
            this.setState({
                exportOpen: true,
            });
        }
    };

    geocodeAddress = (address) => {
        var geocoder = new window.google.maps.Geocoder();

        const self = this;
        geocoder.geocode({ address: address }, function (results, status) {
            if (status === 'OK') {
                var address = results[0].formatted_address;
                var formatted = results[0].formatted_address.split(', ');
                if (formatted.length === 3) {
                    address = formatted[1] + ', ' + formatted[2];
                }
                self.setState({ address: address });
            }
        });
    };

    render() {
        const {
            inspection,
            inspectionAssigns,
            allEmployees,
            t,
        } = this.props;
        const { tab, inspectionAssign } = this.state;

        const tableActionHeader = <TableActionHeader />;

        if (
            this.state.address == null &&
            inspectionAssign &&
            inspectionAssign.result &&
            inspectionAssign.result.gpsLocation &&
            inspectionAssign.result.gpsLocation.lat &&
            inspectionAssign.result.gpsLocation.lon
        ) {
            this.geocodeAddress(
                inspectionAssign.result.gpsLocation.lat +
                    ',' +
                    inspectionAssign.result.gpsLocation.lon
            );
        }

        if (!inspectionAssign) {
            return t('Loading');
        }
        return (
            <div>
                <Tabs
                    value={tab}
                    onChange={this.handleTabChange}
                    className={classes.root}
                    indicatorColor={colors.primaryColor}
                    textColor="secondary"
                    sx={{color: colors.mainTabsColor, '& .Mui-selected': { color: colors.mainTabsSelectedColor } }}
                >
                    <Tab label={t('Information')} href="#informatie" />
                    {inspectionAssign && inspectionAssign.deployed && (
                        <Tab label={t('Results')} href="#resultaten" />
                    )}
                    <Tab label={t('Trend')} href="#trend" />
                </Tabs>
                {inspectionAssign.inspection !== undefined ? (
                    <AppModule hasTabs prepend={tableActionHeader}>
                        {tab === 0 && inspectionAssigns && (
                            <InspectionAssignInformation
                                inspectionAssign={inspectionAssign}
                                allEmployees={allEmployees}
                            />
                        )}
                        {tab === 1 &&
                            inspectionAssign &&
                            inspectionAssign.deployed && (
                                <InspectionResultsView
                                    inspection={inspection}
                                    inspectionAssign={inspectionAssign}
                                />
                            )}

                        {tab === 1 && (
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '84px',
                                    right: '36px',
                                    zIndex: 1500,
                                }}
                            >
                                <div>
                                    <Fab
                                        onClick={this.toggleExport}
                                    >
                                        {this.state && this.state.exportOpen ? (
                                            <CloseIcon />
                                        ) : (
                                            <DownloadIcon />
                                        )}
                                    </Fab>
                                </div>
                                <div
                                    style={
                                        this.state && this.state.exportOpen
                                            ? {
                                                  marginTop: '20px',
                                                  marginLeft: '8px',
                                                  visibility: 'visible',
                                                  transition:
                                                      'margin-top 300ms',
                                              }
                                            : {
                                                  marginTop: '0px',
                                                  marginLeft: '8px',
                                                  visibility: 'hidden',
                                                  transition:
                                                      'margin-top 300ms',
                                              }
                                    }
                                    className={'tooltip'}
                                >
                                    <span
                                        className={
                                            this.state && this.state.exportOpen
                                                ? 'tooltiptextvisible'
                                                : 'tooltiptext'
                                        }
                                        style={{ top: '87px', right: '60px' }}
                                    >
                                        {t('Download PDF file')}
                                    </span>
                                    <Fab
                                        color="primary"
                                        
                                        onClick={this.handlePDFClick}
                                    >
                                        <InsertIcon />
                                    </Fab>
                                </div>
                                <div
                                    style={
                                        this.state && this.state.exportOpen
                                            ? {
                                                  marginTop: '15px',
                                                  marginLeft: '8px',
                                                  visibility: 'visible',
                                                  transition:
                                                      'margin-top 300ms',
                                              }
                                            : {
                                                  marginTop: '0px',
                                                  marginLeft: '8px',
                                                  visibility: 'hidden',
                                                  transition:
                                                      'margin-top 300ms',
                                              }
                                    }
                                    className={'tooltip'}
                                >
                                    <span
                                        className={
                                            this.state && this.state.exportOpen
                                                ? 'tooltiptextvisible'
                                                : 'tooltiptext'
                                        }
                                        style={{ top: '145px', right: '60px' }}
                                    >
                                        {t('Download CSV file')}
                                    </span>
                                    <Fab
                                        color="primary"
                                        
                                        onClick={this.handleCSVClick}
                                    >
                                        <DescIcon />
                                    </Fab>
                                </div>
                            </div>
                        )}
                        {tab === 2 && inspectionAssigns && (
                            <InspectionTrendView
                                inspectionId={this.state.inspectionAssign.inspection.id}
                                allEmployees={allEmployees}
                            />
                        )}

                    </AppModule>
                ) : (
                    <AppModule hasTabs prepend={tableActionHeader}>
                        {tab === 0 && inspectionAssigns && (
                            <InspectionAssignInformation
                                inspectionAssign={inspectionAssign}
                                allEmployees={allEmployees}
                            />
                        )}
                        {tab === 1 &&
                            inspectionAssign &&
                            inspectionAssign.deployed && (
                                <InspectionResultsView
                                    inspection={inspection}
                                    inspectionAssign={inspectionAssign}
                                />
                            )}

                        {tab === 1 && (
                            <div
                                className={classnames({
                                    [classes.button]: true,
                                    'mui-fixed': true,
                                })}
                            >
                                <div className={'tooltip'}>
                                    <span
                                        className={'tooltiptext'}
                                        style={{ top: '60px' }}
                                    >
                                        {t('Download inspection as PDF')}
                                    </span>
                                    <Fab
                                         
                                        onClick={this.handlePDFClick}
                                    >
                                        <DescIcon />
                                    </Fab>
                                </div>
                            </div>
                        )}
                    </AppModule>
                )}
            </div>
        );
    }
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(compose(withTranslation(), )(InspectionDetailView))
);
